import store from '@/store/store'
import app from '@/main'

export default socket => {
  socket.on('notices', function(data) {
    store.commit('notices/ADD_NOTICE', data)
    app.$vs.notify({
      title: data.title,
      text: data.description ? data.description : null,
      iconPack: 'feather',
      icon: data.category === 'success' ? 'icon-check' : 'icon-alert-circle',
      color: data.category ? data.category : 'primary',
      time: 8000
    })
  })
}
